import React from 'react';
import { Chip } from '../../../ui/core';
import { CircleIcon, CheckCircleIcon, CancelIcon } from '../../../ui/icons';
import { StandbyStatus } from '../../../models/Rides';

/**
 * Status chip for a standby ride request.
 *
 * Labels mirror the enum ("Unconfirmed", not "Did not go") so the chip matches
 * the value an engineer greps for in the data and the logs. The known cost is
 * that "Unconfirmed" reads as "still pending" to anyone who does not know the
 * enum, when it actually means the booking failed to reach go and Hitch
 * cancelled it.
 *
 * Separate from RideStatusChip rather than folded into it: that one switches on
 * RideStatus, and a standby row carries both statuses at once.
 */
export const StandbyStatusChip = ({ status }) => {
  switch (status) {
    case StandbyStatus.pending:
      return <Chip icon={<CircleIcon sx={{ fontSize: 16 }} />} color="warning" label="Pending" />;
    case StandbyStatus.confirmed:
      return <Chip icon={<CheckCircleIcon sx={{ fontSize: 16 }} />} color="info" label="Confirmed" />;
    case StandbyStatus.cancelled:
      return <Chip icon={<CancelIcon sx={{ fontSize: 16 }} />} color="cancelled" label="Cancelled" />;
    case StandbyStatus.unconfirmed:
      return <Chip icon={<CancelIcon sx={{ fontSize: 16 }} />} color="warning" label="Unconfirmed" />;
    default:
      return null;
  }
};

export default StandbyStatusChip;
